import React from "react";
import LinkedTravelRowCard, { getLinkedTravelInfo } from "./linkedtravelrow";

interface IProps {
  travels: server.dto.ShowToTravelAppointment[]
  icon: JSX.Element
  title: string
  unlink: (appointmentId: number) => void
  setDisplayInAdvancing: (appointment: server.dto.AppointmentForList, displayInAdvancing: boolean) => void
  canLinkUnlinkTravel: boolean
}

// TODO: See if these get updated and how
const LinkedTravelRows = (props: IProps) => {
  if (!props.travels || props.travels.length === 0) {
    return null;
  }

  return (<div className="margin-bottom">

    <div className="list-with-gaps">
      <div className="list-with-gaps-header">
        <div className="flex gap align-center" style={{ background: "none", paddingTop: 0, paddingLeft: 4 }}>
          <div>
            {props.icon}
          </div>
          <div className="">
            <h3>{props.title}</h3>
          </div>
        </div>
      </div>

      <div className="list-with-gaps-body gap">
        {props.travels
          .map((travel) => (
            <LinkedTravelRowCard
              key={getLinkedTravelInfo(travel.appointment).id}
              appointment={travel.appointment}
              displayInAdvancing={travel.displayInAdvancing}
              unlink={props.unlink}
              setDisplayInAdvancing={props.setDisplayInAdvancing}
              canLinkUnlinkTravel={props.canLinkUnlinkTravel}
            />
          ))}
      </div>
    </div>
  </div>
  );
};

export default LinkedTravelRows;